/**
 * Amasty Multiple Wishlist compatibility for ScandiPWA
 * @copyright Scandiweb, Inc. All rights reserved.
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import Field from 'Component/Field';
import {
    FieldType,
} from 'Component/Field/Field.config';
import Form from 'Component/Form';
import Loader from 'Component/Loader';

import { ItemType, WishlistsType } from '../../type/MultipleWishlist.type';
import MultipleWishlistItem from '../MultipleWishlistItem';

/** @namespace Scandiweb/AmastyMultipleWishlist/Component/MultipleWishlistPopup/Component */
export class MultipleWishlistPopupComponent extends PureComponent {
    static propTypes = {
        wishlists: WishlistsType.isRequired,
        wishlistItem: ItemType.isRequired,
        handleClick: PropTypes.func.isRequired,
        handleChangeTab: PropTypes.func.isRequired,
        handleCreateListClick: PropTypes.func.isRequired,
        handleCreateList: PropTypes.func.isRequired,
        activeTab: PropTypes.number.isRequired,
        isLoading: PropTypes.bool.isRequired,
        isCreateListClicked: PropTypes.bool.isRequired,
        handleFieldChange: PropTypes.func.isRequired,
        isSaved: PropTypes.bool.isRequired,
        showNotification: PropTypes.func.isRequired,
    };

    renderList() {
        const {
            wishlists: { items },
        } = this.props;

        return items.map(this.renderWishlistsItem);
    }

    renderEmptyMessage() {
        const { wishlists: { emptyMessage } } = this.props;

        return (
            <div block="MultipleWishlist" elem="EmptyMessage">
                { emptyMessage }
            </div>
        );
    }

    // eslint-disable-next-line @scandipwa/scandipwa-guidelines/no-arrow-functions-in-class
    renderWishlistsItem = (item, idx) => {
        const { handleClick, showNotification } = this.props;
        const { viewUrl } = item;

        if (!viewUrl) {
            return this.renderEmptyMessage();
        }

        return (
            <MultipleWishlistItem
              key={ idx }
              item={ item }
              handleClick={ handleClick }
              showNotification={ showNotification }
            />
        );
    };

    renderWishlistsTab() {
        const { activeTab, handleChangeTab } = this.props;
        const active = !activeTab ? 'ItemTab-active' : 'ItemTab';

        return (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
            <li
              key="wish"
              block="MultipleWishlist"
              elem={ active }
              title="Open Wish Lists"
              onClick={ handleChangeTab }
              value={ 0 }
            >
                { __('Wish Lists') }
            </li>
        );
    }

    renderRequisitionlistsTab() {
        const { activeTab, handleChangeTab } = this.props;
        const active = activeTab ? 'ItemTab-active' : 'ItemTab';

        return (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
            <li
              key="requisition"
              block="MultipleWishlist"
              elem={ active }
              title="Open Requisiton Lists"
              onClick={ handleChangeTab }
              value={ 1 }
            >
                { __('Requisition Lists') }
            </li>
        );
    }

    renderTabs() {
        const { wishlistItem } = this.props;

        if (Object.keys(wishlistItem).length) {
            return null;
        }

        return (
            <ul block="MultipleWishlist" elem="Tabs" key="wishlistTabs">
                { this.renderWishlistsTab() }
                { this.renderRequisitionlistsTab() }
            </ul>
        );
    }

    renderLoader() {
        const { isLoading } = this.props;

        return <Loader isLoading={ isLoading } />;
    }

    renderCreateListButton() {
        const { handleCreateListClick } = this.props;

        return (
            <div block="MultipleWishlist" elem="CreateBlock">
                <button
                  block="MultipleWishlist"
                  elem="CreateListButton"
                  label={ __('Create List') }
                  onClick={ handleCreateListClick }
                >
                    { __('+ Create New List') }
                </button>
            </div>
        );
    }

    renderAddButton() {
        return (
            <button
              block="MultipleWishlist"
              elem="AddButton"
              type="submit"
            >
                { __('Add') }
            </button>
        );
    }

    renderCreateListForm() {
        const { isCreateListClicked, isSaved, handleCreateList } = this.props;

        if (!isCreateListClicked || isSaved) {
            return null;
        }

        return (
            <div block="MultipleWishlist" elem="Form">
                <Form
                  key="CreateList"
                  id="MultipleWishlistForm"
                  onSubmit={ handleCreateList }
                >
                    { this.renderCreateListField() }
                    { this.renderAddButton() }
                </Form>
            </div>
        );
    }

    renderCreateListField() {
        const { handleFieldChange } = this.props;

        return (
            <Field
              id="listName"
              type={ FieldType.TEXT }
              name="listName"
              validation={ ['notEmpty'] }
              events={ {
                  onChange: handleFieldChange,
              } }
              validateOn={ ['onChange'] }
              validationRule={ {
                  isRequired: true,
              } }
            />
        );
    }

    render() {
        const { wishlistItem, wishlistItem: { name: wishlistName } } = this.props;
        const name = Object.keys(wishlistItem).length ? __('%s', wishlistName) : __('My Wish Lists');

        return (
            <>
                <h2
                  block="MyAccount"
                  elem="Heading"
                >
                    { name }
                </h2>
                <div block="MultipleWishlist">
                    { this.renderTabs() }
                    { this.renderCreateListButton() }
                    { this.renderCreateListForm() }
                    { this.renderList() }
                    { this.renderLoader() }
                </div>
            </>
        );
    }
}

export default MultipleWishlistPopupComponent;
